const o=(o,t)=>Math.floor((o-1)/t)*t+1,t=(o,t,a)=>Math.min(o+t-1,a),a=(o,t)=>t-o+1;export{o as getFirstPage,t as getLastPage,a as getPageButtonCount};
